var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.hidden,
          expression: "!hidden"
        }
      ],
      ref: "sidebarElem",
      staticClass: "sidebar",
      class: ["sidebar--" + _vm.position, { "sidebar--show": _vm.isOpen }],
      attrs: { id: "sidebar", "aria-labelledby": "filter-button" }
    },
    [
      _c("div", { staticClass: "sidebar__inner" }, [
        _c("div", { staticClass: "sidebar__top" }, [
          _c("button", {
            staticClass: "button button--close",
            attrs: { title: "Lukk" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.close($event)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sidebar__filters" }, [_vm._t("default")], 2)
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }